import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ImageMask } from 'elements/visual/ImageMask';
import { EColors, EGrads } from 'libs/styles/styling';
import React from 'react';
import styled, { css } from 'styled-components/macro';

interface Props {
    iconName: IconName;
    iconSet: IconPrefix;
    title: string;
    highlighted?: boolean;
    children?: React.ReactNode;
    className?: string;
}

export const SetEditorHeader = (props: Props): JSX.Element => {
    const highlightPar = !!props.highlighted;

    return (
        <S_SetEditorHeader className={props.className} $highlighted={highlightPar}>
            <S_Left>
                <S_Icon icon={[props.iconSet, props.iconName]} $highlighted={highlightPar} />
                <S_Title $highlighted={highlightPar}>{props.title}</S_Title>
            </S_Left>
            <div>{props.children}</div>
            {props.highlighted && (
                <ImageMask randomizePosition={true} step={20} image="contour" repeat={true} />
            )}
        </S_SetEditorHeader>
    );
};

const S_SetEditorHeader = styled.div<{ $highlighted: boolean }>`
    display: flex;
    width: 100%;
    height: 50px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${EColors.BLACK3};
    background: ${EGrads.BLACK_GRAD};
    padding: 0 20px;
    box-sizing: border-box;
    flex-shrink: 0;
    position: relative;
    ${(props) => {
        if (props.$highlighted) {
            return css`
                background: ${EGrads.ACC2_GRAD};
            `;
        }
    }}
`;

const S_Left = styled.div`
    display: flex;
    align-items: center;
`;

const S_Icon = styled(FontAwesomeIcon)<{ $highlighted: boolean }>`
    color: ${(props) => (props.$highlighted ? EColors.WHITE : EColors.GREY3)};
    font-size: 20px;
    margin: 0 15px 0 0;
`;

const S_Title = styled.span<{ $highlighted: boolean }>`
    font-size: 14px;
    color: ${(props) => (props.$highlighted ? EColors.WHITE : EColors.GREY3)};
`;
